import { useEffect, useRef, useContext } from 'react';
import { useNavigationType } from 'react-router-dom';
import { Container } from '@chakra-ui/react';
import useOrganizationStatus from '../../../hooks/useOrganisationStatus';
import EmptyDefaultSvgAnimated from '../../../theme/illustrations-animated//EmptyDefaultSvgAnimated';
import Breadcrumbs from '../../../common/Breadcrumbs';
import PassesList from './PassesList';
import PassesListHeader from './PassesListHeader';
import { useAppDispatch, useAppSelector } from '../../../store/redux/hooks';
import {
  initialFilterValues,
  initialSortValues,
  resetPageIndex,
  selectNavigatedFromPassPage,
  setNavigatedFromPassPage,
  setNewFiltersSet,
  updateFilterValues,
  updateSortValues,
  updateTotalActiveFilters,
} from '../../../store/redux/slices/passList.slice';
import { MeContext } from '../../../context/MeContext';
import type { MeContextState } from '../../../store/types/account';

const resetFilters = (dispatch) => {
  dispatch(updateFilterValues(initialFilterValues));
  dispatch(updateSortValues(initialSortValues));
  dispatch(updateTotalActiveFilters(0));
  dispatch(setNewFiltersSet(false));
  dispatch(resetPageIndex());
};

const PassesListPage = () => {
  const dispatch = useAppDispatch();
  const navigationType = useNavigationType();
  const fromPassPage = useAppSelector(selectNavigatedFromPassPage);
  const fromPassPageRef = useRef(fromPassPage);
  const meCtx = useContext(MeContext) as { state: MeContextState };
  const { filterEntity } = meCtx.state;
  const filterEntityRef = useRef(filterEntity);

  useEffect(() => {
    const shouldPreserve = navigationType === 'POP' && fromPassPageRef.current;
    dispatch(setNavigatedFromPassPage(false));
    if (!shouldPreserve) {
      resetFilters(dispatch);
    }
  }, [dispatch, navigationType]);

  useEffect(() => {
    if (filterEntity !== filterEntityRef.current) {
      filterEntityRef.current = filterEntity;
      resetFilters(dispatch);
    }
  }, [dispatch, filterEntity]);
  const modeSvgIcon = <EmptyDefaultSvgAnimated />;
  const { shouldRender, components } = useOrganizationStatus(modeSvgIcon);

  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'passes',
      linkUrl: '/passes',
    },
  ];
  return (
    <Container display="flex" flexDir="column" flex="1" pb={6}>
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <PassesListHeader />
      {components}
      {shouldRender && <PassesList />}
    </Container>
  );
};

export default PassesListPage;
